import { Onboarding, OnboardingWhatsNew } from "@edp-models/onboarding.model";

export interface IOnboardingState {
    onboarding: Onboarding | null;
    onboardingWhatsNew: OnboardingWhatsNew | null;
    whatsNewlastAPIError: Error;
}

export const initialOnboardingState: IOnboardingState = {
    onboarding: null,
    onboardingWhatsNew: null,
    whatsNewlastAPIError: null,
};
